import React from "react";
import ServiceDetailLayout from "../../components/service-detail-layout";
import biomechanics from "../../assets/img/biomechanics-assessment.jpg";

/**
 * Biomechanical Assessment detail page component
 */
const BiomechanicalAssessmentDetail = () => {
  return (
    <ServiceDetailLayout
      title="Biomechanical Assessment"
      description="Comprehensive biomechanical assessment to diagnose imbalances and weaknesses in feet and leg joints. Professional movement analysis and treatment planning."
      image={biomechanics}
      imageAlt="Biomechanical Assessment"
    >
      <h1 className="gs-u-mb+">Biomechanical Assessment</h1>
      <p className="text--large gs-u-mb++">
        A biomechanical evaluation involves checking how well your lower body
        works. It's designed to figure out what's causing your discomfort or
        symptoms.
      </p>

      <p className="gs-u-mb+">
        If you're worried about your knees, ankles, or feet, a biomechanical
        evaluation can spot any issues or irregularities in how they're
        structured, aligned, and how they function. It can also pinpoint the
        kind of pressure your body is under when you're walking or running.
      </p>

      <p className="gs-u-mb++">
        Understanding how your lower body works and where issues might be coming
        from, a podiatrist can recommend ways to ease any pain you're feeling.
      </p>

      <p className="gs-u-mb++">
        During a biomechanical evaluation, your podiatrist might examine your
        bones, joints, muscles, tendons, ligaments, and nerves. They'll also
        look at how you walk and your posture and check your shoes to see if
        they're affecting your feet or ankles.
      </p>

      <h2 className="gs-u-mb+">
        What happens during a biomechanical assessment?
      </h2>
      <p className="gs-u-mb+">
        Upon your arrival for the evaluation, a podiatrist will perform tests to
        look for possible irregularities and reasons behind pain in the feet,
        ankles, knees, or back.
      </p>

      <p className="gs-u-mb+">Examinations may include:</p>
      <ul className="gs-u-mb++ benefits-list">
        <li>
          <strong>An examination of your bones and joints</strong> to check how
          far your joints can move. This allows your podiatrist to identify
          issues like arthritis, excessive joint flexibility, joint
          dislocations, or bunion deformities.
        </li>
        <li>
          <strong>Examination of muscle, tendon, and ligament health.</strong>{" "}
          Your podiatrist will examine these components and tissues to identify
          any signs of weakness or tightness. They will also be able to detect
          issues with tendinopathy (injured tendons).
        </li>
        <li>
          <strong>A neurological assessment.</strong> This will encompass tests
          for feeling and sense of body position to identify any issues with
          nerves. It could also include evaluating the reflexes of tendons (such
          as the knee jerk reaction).
        </li>
        <li>
          <strong>Examination of walking and standing positions.</strong> By
          observing your manner of walking and standing, your foot specialist
          can detect possible issues, like an imbalance in leg length or the
          shape of your back. Occasionally, reviewing a video can make these
          issues more apparent.
        </li>
        <li>
          <strong>Shoe evaluation,</strong> alongside the biomechanical review,
          examining your shoes can assist a podiatrist in spotting any issues.
          Shoes that don't fit properly can lead to various foot health issues.
          At The Moffat Foot Clinic, we advise that you bring 2-4 pairs of shoes
          you frequently wear to your first visit.
        </li>
      </ul>

      <p className="gs-u-mb++">
        Your podiatrist can detect any irregularities, damages, or health
        issues, along with their root reasons. They can provide guidance on the
        most effective remedies.
      </p>

      <h2 className="gs-u-mb+">What treatments might the analysis lead to?</h2>
      <p className="gs-u-mb+">
        The therapies provided to you will differ based on the results of your
        evaluation. After your check-up, your foot specialist will be able to
        suggest the most appropriate treatment plan tailored to your specific
        requirements.
      </p>

      <p className="gs-u-mb+">
        At The Moffat Foot Clinic, we address a variety of widespread issues —
        ranging from ingrown toenails and skin infections to gout, knee
        discomfort, and differences in leg length.
      </p>

      <p className="gs-u-mb+">We offer a range of services, including:</p>
      <ul className="gs-u-mb++ benefits-list">
        <li>Footwear recommendations</li>
        <li>Activity modification</li>
        <li>Specific exercises regimes</li>
        <li>Joint manipulations</li>
        <li>Soft tissue mobilisations</li>
        <li>Prescription insoles/orthotics</li>
        <li>Referral for surgical assessment</li>
        <li>Steroid injections</li>
      </ul>

      <p className="gs-u-mb++">
        After your biomechanical evaluation, we might offer you custom
        orthotics, advise you on changes in your shoes and way of living, or
        direct you to get diagnostic scans or a meeting with a surgeon.
      </p>

      <p className="gs-u-mb++">
        Are you feeling any aches or soreness in your toes, ankles, or lower
        legs? If you're uncertain about why this is happening, a biomechanical
        evaluation can assist in identifying the underlying issue. Reach out to
        The Moffat Foot Clinic to schedule a check-up and discover the most
        suitable solution.
      </p>
    </ServiceDetailLayout>
  );
};

export default BiomechanicalAssessmentDetail;
